import { useMemo } from 'react';
import {
  investmentFirstCellRichHtml,
  investmentProductDescriptionContent,
  sanitizeInvestmentDescriptionHtml,
} from '@/editor/investmentTableCellContent';

/**
 * The whole description, including the title line catalog descriptions open with: the
 * quote shows the product name nowhere else, so the customer would not see which product
 * the amount belongs to.
 */
export default function InvestmentProductDescription({ title, descriptionHtml }: {
  title: string;
  descriptionHtml?: string;
}) {
  const html = useMemo(() => {
    if (!descriptionHtml) return undefined;
    const content = investmentProductDescriptionContent(title, descriptionHtml);
    const richHtml = investmentFirstCellRichHtml({ type: 'tableCell', content });
    return richHtml ? sanitizeInvestmentDescriptionHtml(richHtml) : undefined;
  }, [title, descriptionHtml]);

  return html ? <div
    className="investment-product-description investment-description-rich [&_strong]:font-semibold [&_b]:font-semibold"
    style={{ minWidth: 0, overflowWrap: 'anywhere' }}
    dangerouslySetInnerHTML={{ __html: html }}
  /> : <div className="investment-product-description" style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{title}</div>;
}
